export { default } from "./ResetPasswordConfirmation";
